/** Use geometry-based edges (AssetProcessor + EdgeManager) instead of Sobel post-processing */
export const USE_GEOMETRY_EDGES = false;

/** Resolution scale for Sobel depth pass (2 = 2x sampling, sharper edges) */
export const EDGE_RESOLUTION_SCALE = 2;
